import firebase from "firebase"

const firebaseApp = firebase.initializeApp ({
    apiKey: "AIzaSyDe7X7ArCYvD7l6TamTFgXbcLNo3rDg9fc",
    authDomain: "instagram-clone-d1dbc.firebaseapp.com",
    databaseURL: "https://instagram-clone-d1dbc-default-rtdb.firebaseio.com",
    projectId: "instagram-clone-d1dbc",
    storageBucket: "instagram-clone-d1dbc.appspot.com",
    messagingSenderId: "354505405421",
    appId: "1:354505405421:web:488653147f08a26c3d6de4",
    measurementId: "G-PZRW01CT0F"
  });

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();

  export {db, auth, storage};